<script lang="ts" module>
  import type { SpellCheckMatch } from '@/teoCore/text/SpellCheckHandler';
  import type { TeoText } from '@/teoCore/text/TeoText';
  import Assistant, { type CardProps } from '@/ui/elements/assistant/Assistant.svelte';
  import { useTeoEventObserver } from '@/utils/use-teo-event-observer.svelte';

  import ContinueActionsComponent from '../../continueActions/ContinueActionsComponent.svelte';
</script>

<script lang="ts">
  const { teoText }: { teoText: TeoText } = $props();

  const loading = useTeoEventObserver({
    initialValue: false,
    update: (evebtName, loading) => loading,
    target: teoText.spellCheck.events,
    events: ['loading'],
  });

  const cards = useTeoEventObserver({
    initialValue: createCardProps(teoText.spellCheck.currentMatches),
    update: (eventName, detail) => createCardProps(detail),
    target: teoText.spellCheck.events,
    events: ['currentMatchesChanged'],
  });

  const focusedMatch = useTeoEventObserver({
    initialValue: teoText.spellCheck.focusedMatch,
    update: () => teoText.spellCheck.focusedMatch,
    target: teoText.spellCheck.events,
    events: ['matchFocused'],
  });

  teoText.spellCheck.check();

  function onImprovementClick(entryKey: string, improvementKey: string) {
    teoText.spellCheck.useImprovement(entryKey, improvementKey);
  }

  function onDimensionChange(dimension: string | undefined) {
    if (!dimension) {
      teoText.spellCheck.focusMatch(undefined);
      return;
    }
    const match = teoText.spellCheck.getMatchByKey(dimension);
    teoText.spellCheck.focusMatch(match);
  }

  function createCardProps(matches: SpellCheckMatch[]): CardProps[] {
    return matches.map((match) => ({
      cardLabel: match.variant === 'spelling' ? 'Rechtschreibung' : 'Grammatik',
      contentText: match.message,
      variantLabel: match.variantLabel,
      improvements: match.improvements,
      key: match.key,
      variant: match.variant,
    }));
  }
</script>

<Assistant
  title="Korrekturvorschläge"
  loading={loading.current}
  {onImprovementClick}
  cards={cards.current}
  dimension={focusedMatch.current?.key}
  {onDimensionChange}
  noErrorsContent={{
    title: 'Sehr gut!',
    text: 'Keine Korrekturvorschläge vorhanden.',
  }}
>
  {#snippet noErrorsInfo()}
    <ContinueActionsComponent actions={['newText', 'brandScanner', 'performanceReport']} />
  {/snippet}
</Assistant>
